var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('div',[_c('ul',{staticClass:"list-inline",attrs:{"data-test":"variant-selector-list"}},_vm._l((_vm.attributes),function(ref){
var name = ref[0];
var id = ref[1];
var values = ref[2];
return _c('li',{key:name},[_c('AttributeSelect',{attrs:{"product":_vm.product,"values":values,"sku":_vm.sku,"name":name,"id":id,"selected":_vm.selected,"variantCombinations":_vm.variantCombinations}})],1)}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }